<div class="container pt-3 mx-auto mt-5 row">
  <div class="text-center col-12 col-sm-4 text-sm-left">
    <app-accentry-logo class="d-block mx-auto mb-4 mt-3"/>
    @if (selectedCompanyGroup === 'ANL') {
      <img class="logo" src="./assets/images/logos/accell-western-europe.svg" alt="Accell Western Europe"
        />
    }
    @if (selectedCompanyGroup === 'LAP') {
      <img class="mt-2 logo" src="./assets/images/accell-sud.png" alt="Accell Sud" />
    }
    @if (selectedCompanyGroup === 'TUN') {
      <img class="mt-2 logo" src="./assets/images/Tunturi-logo.png" alt="Tunturi" />
    }
    @if (selectedCompanyGroup === 'WG') {
      <a href="https://winora-group.com/de/" target="_blank">
        @if (applicationService.checkIfDealerHasCompany(101)) {
          <img class="logo" src="./assets/images/Winora-footer.png" alt="Winora"
            />
        }
      </a>
      <a href="https://www.bike-parts.de/" target="_blank">
        @if (applicationService.checkIfDealerHasCompany(102)) {
          <img class="ms-2 logo" src="./assets/images/Winora-bike-parts-logo-color.png"
            alt="E. Wiener Bike Parts" />
        }
      </a>
    }
    @if (selectedCompanyGroup === 'GHO') {
      <a href="https://www.ghost-bikes.com/" target="_blank">
        <img class="logo" src="./assets/images/Ghost-logo.png" alt="Ghost" style="max-width: 200px;"/>
      </a>
    }
    @if (selectedCompanyGroup === 'VAR') {
      <img class="logo w-100" src="./assets/images/tunturi-accell-black.png" alt="Tunturi Sweden" />
    }
    @if (selectedCompanyGroup === 'RAL') {
      <img class="logo w-100" src="./assets/images/logos/ral.png" alt="Raleigh" title="Accell UK"
        style="max-height: initial;" />
    }
    @if (selectedCompanyGroup === 'COM') {
      <img class="me-2 logo" src="./assets/images/comet-logo-color.png" alt="Comet" />
    }
    <span class="mt-5 d-block">Copyright Accell Group &copy; {{ currentYear }}</span>
  </div>
  @if (showLinks) {
    <div class="mt-3 col-12 col-sm-4 items">
      <h4 class="mb-3">{{ "QUICKLINKS" | translate }}</h4>
      @defer (on viewport) {
      <app-quick-links class="links-homepage" [homepageQuicklinks]="true"></app-quick-links>
      } @placeholder {
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    }
  </div>
  <div class="mt-3 col-12 col-sm-4 items">
    <h4 class="mb-3">{{ "INFORMATION" | translate }}</h4>
    @if (selectedCompanyGroup !== 'WG' && selectedCompanyGroup !== 'GHO') {
      <ul class="list-group list-group-flush">
        <li class="list-group-item bg-transparent ps-0 py-1">@if (selectedCompanyGroup === 'ANL') {
          <a
            [routerLink]="selectedCompanyGroup + '/companyPage/960422033'" class="link">{{ "REMOTE_SUPPORT" |
          translate }}</a>
        }</li>
        <li class="list-group-item bg-transparent ps-0 py-1">@if (selectedCompanyGroup === 'ANL') {
          <a
            [routerLink]="selectedCompanyGroup + '/companyPage/960422036'" class="link">{{ "CONTACT_COMPANIES" |
          translate }}</a>
        }</li>
        <li class="list-group-item bg-transparent ps-0 py-1">
          @if (selectedCompanyGroup !== 'RAL' && selectedCompanyGroup !== 'COM') {
            <a href="#" class="link" (click)="getLink('terms_and_conditions', $event)"
            >{{ "GENERAL_TERMS_AND_CONDITIONS" | translate }}</a>
          }
        </li>
        <li class="list-group-item bg-transparent ps-0 py-1">
          @if (selectedCompanyGroup === 'RAL') {
            <a href="#" class="link" [routerLink]="selectedCompanyGroup + '/companyPage/terms-conditions'"
            >{{ "GENERAL_TERMS_AND_CONDITIONS" | translate }}</a>
          }
        </li>
        <li class="list-group-item bg-transparent ps-0 py-1">
          @if (selectedCompanyGroup === 'COM') {
            <a href="#" class="link" [routerLink]="selectedCompanyGroup + '/companyPage/terms-conditions'"
            >{{ "GENERAL_TERMS_AND_CONDITIONS" | translate }}</a>
          }
        </li>
        <li class="list-group-item bg-transparent ps-0 py-1">@if (selectedCompanyGroup === 'COM') {
          <a
            [routerLink]="selectedCompanyGroup + '/companyPage/960422153'" class="link">{{ "PRIVACY_STATEMENT" |
          translate }}</a>
        }</li>
      </ul>
    }
    @if (selectedCompanyGroup === 'WG') {
      <ul class="list-group list-group-flush">
        <li class="list-group-item bg-transparent ps-0 py-1">
          <a [routerLink]="selectedCompanyGroup + '/companyPage/allgemeine-geschaeftsbedingungen'" class="link">{{
          "GENERAL_TERMS" | translate }}</a>
        </li>
        <li class="list-group-item bg-transparent ps-0 py-1">
          <a [routerLink]="selectedCompanyGroup + '/companyPage/allgemeine-geschaeftsbedingungen-accell-suisse'" class="link">{{
          "GENERAL_TERMS2" | translate }}</a>
        </li>
        <li class="list-group-item bg-transparent ps-0 py-1"><a
          [routerLink]="selectedCompanyGroup + '/companyPage/960422118'" class="link">{{ "PRIVACY_STATEMENT" |
        translate }}</a>
        <li class="list-group-item bg-transparent ps-0 py-1">
          <a [routerLink]="selectedCompanyGroup + '/companyPage/kontakt'" class="link">{{ "CONTACT" | translate }}</a>
        </li>
        <li class="list-group-item bg-transparent ps-0 py-1">
          <a [routerLink]="selectedCompanyGroup + '/companyPage/960422136'" class="link" href="#">{{ "IMPRESSUM" |
          translate }}</a>
        </li>
        <li class="list-group-item bg-transparent ps-0 py-1"><a
          [routerLink]="selectedCompanyGroup + '/companyPage/nutzungsbedingungen-datenschutz'" class="link">{{
        "GENERAL_TERMS_AND_CONDITIONS" | translate }}</a></li>
      </ul>
    }
    @if (selectedCompanyGroup === 'GHO') {
      <ul class="list-group list-group-flush">
        <li class="list-group-item bg-transparent ps-0 py-1"><a
          [routerLink]="selectedCompanyGroup + '/companyPage/960421819'" class="link">{{ "GENERAL_TERMS" | translate
        }}</a></li>
        
        <li class="list-group-item bg-transparent ps-0 py-1"><a
          [routerLink]="selectedCompanyGroup + '/companyPage/allgemeine-geschaeftsbedingungen-accell-suisse'" class="link">{{ "GENERAL_TERMS2" | translate
        }}</a></li>
        <li class="list-group-item bg-transparent ps-0 py-1"><a
          [routerLink]="selectedCompanyGroup + '/companyPage/960422123'" class="link">{{ "PRIVACY_STATEMENT" |
        translate }}</a></li>
        <li class="list-group-item bg-transparent ps-0 py-1"><a
        [routerLink]="selectedCompanyGroup + '/companyPage/kontakt'" class="link">{{ "CONTACT" | translate }}</a>
      </li>
      <li class="list-group-item bg-transparent ps-0 py-1"><a
        [routerLink]="selectedCompanyGroup + '/companyPage/960422209'" class="link" href="#">{{ "IMPRESSUM" |
      translate }}</a></li>
      <li class="list-group-item bg-transparent ps-0 py-1"><a
        [routerLink]="selectedCompanyGroup + '/companyPage/nutzungsbedingungen-datenschutz'" class="link">{{
      "GENERAL_TERMS_AND_CONDITIONS" | translate }}</a></li>
    </ul>
  }
</div>
}
</div>
